export default {
  placeholders: {
    delivery_zip_code: 'Kod pocztowy',
    delivery_city: 'Miasto',
    delivery_street_number: 'Numer domu',
    delivery_street_name: 'Nazwa ulicy',
    type_your_address: 'Wpisz swój adres',
  },
  errors: {
    address_suggestions_unavailable:
      'Nie udało się załadować podpowiedzi adresów. Nadal możesz wpisać swój adres poniżej.',
  },
  buttons: {
    retry: 'Spróbuj ponownie',
  },
};
